import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {HTHMaxWinSymbol} from "../symbols/HTHMaxWinSymbol";
import {HTHSymbol} from "../symbols/HTHSymbol";
import {gsap} from "gsap";
import {HTHEnhancerSymbol} from "../symbols/HTHEnhancerSymbol";

export class HTHGodModeMaxWinPresentation implements SimplePresentation {
    name: "HTHGodModeMaxWinPresentation";

    shouldRun(): boolean {
        return HTH.model.isGodModeMaxWin;
    }

    start(controller: SimplePresentationRunnerController) {
        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onComplete: () => {
                controller.finish();
            }
        });

        controller.setSkipCallback();
        const sym: HTHSymbol = HTH.reelArea.getSymbol(HTH.model.maxWinSymbolPosition);
        tl.add((<HTHMaxWinSymbol>((<HTHEnhancerSymbol>sym).revealedSymbol)).addMaxWinEffect());
    }

}